/** API may send boolean true or string "true" for web settings flags. */
export function isPaymentSettingOn(value) {
    return value === true || value === 'true' || value === 'True'
}

export function normalizeRegistrationSubdomain(subdomain) {
    return String(subdomain || '').trim().toLowerCase()
}

export function getRegistrationAllowCheckStorageKey(subdomain) {
    const normalized = normalizeRegistrationSubdomain(subdomain)
    return normalized ? `AllowCheck:${normalized}` : 'AllowCheck'
}

/** Parent login setting from api/GetSchoolSettings (stored in localStorage per subdomain). */
export function isRegistrationAllowCheckEnabled(subdomain) {
    return isPaymentSettingOn(localStorage.getItem(getRegistrationAllowCheckStorageKey(subdomain)))
}

export function storeRegistrationAllowCheckFlag(value, subdomain) {
    localStorage.setItem(getRegistrationAllowCheckStorageKey(subdomain), value || false)
}
